import { isEmpty } from '../baseUtils';
import { deleteWckIssueSearchKeyword } from './flagsPreference';

const isSsr = (): boolean => typeof window === 'undefined';
export const getCooikeShareFacebook = async () => {
  let shareFacebook = '';
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    shareFacebook = cookie.get('shareFacebook')?.value as string;
  } else {
    const { getCookie } = await import('cookies-next');
    shareFacebook = getCookie('shareFacebook') as string;
  }
  return shareFacebook;
};

export const setCookieShareFacebook = async (val: string) => {
  if (isEmpty(val)) {
    deleteWckIssueSearchKeyword();
    return;
  }
  const todayDate = new Date();
  todayDate.setDate(todayDate.getDate() + 1);

  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    cookie.set('shareFacebook', val, {
      path: '/',
      domain: '.wconcept.co.kr',
      expires: todayDate,
    });
  } else {
    const { setCookie } = await import('cookies-next');
    setCookie('shareFacebook', val, {
      path: '/',
      domain: '.wconcept.co.kr',
      expires: todayDate,
    });
  }
};

export const getCooikeShareKakaotalk = async () => {
  let shareKakaotalk = '';
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    shareKakaotalk = cookie.get('shareKakaotalk')?.value as string;
  } else {
    const { getCookie } = await import('cookies-next');
    shareKakaotalk = getCookie('shareKakaotalk') as string;
  }
  return shareKakaotalk;
};

export const setCookieShareKakaotalk = async (val: string) => {
  if (isEmpty(val)) {
    deleteWckIssueSearchKeyword();
    return;
  }
  const todayDate = new Date();
  todayDate.setDate(todayDate.getDate() + 1);

  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    cookie.set('shareKakaotalk', val, {
      path: '/',
      domain: '.wconcept.co.kr',
      expires: todayDate,
    });
  } else {
    const { setCookie } = await import('cookies-next');
    setCookie('shareKakaotalk', val, {
      path: '/',
      domain: '.wconcept.co.kr',
      expires: todayDate,
    });
  }
};

// wckMktAdValue(알림톡수신동의여부) 값 조회

export const getCookieWckMktAdValue = async () => {
  let wckMktAdValue = 'N';
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    wckMktAdValue = cookie.get('wckMktAdValue')?.value as string;
  } else {
    const { getCookie } = await import('cookies-next');
    wckMktAdValue = getCookie('wckMktAdValue') as string;
  }
  if (isEmpty(wckMktAdValue)) {
    wckMktAdValue = 'N';
  }
  return wckMktAdValue;
};

// wckMktValue(알림톡수신동의여부) 세팅

export const setCookieWckMKtAdValue = async (val: 'Y' | 'N') => {
  if (isEmpty(val)) {
    return;
  }
  const date = new Date();
  // 24시간 저장
  date.setHours(date.getHours() + 24);

  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    cookie.set('wckMktAdValue', val, {
      path: '/',
      domain: '.wconcept.co.kr',
      expires: date,
    });
  } else {
    const { setCookie } = await import('cookies-next');
    setCookie('wckMktAdValue', val, {
      path: '/',
      domain: '.wconcept.co.kr',
      expires: date,
    });
  }
};

export const getCookieWckRPImage = async () => {
  let wckRPImage = '';
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    wckRPImage = cookie.get('wckRPImage')?.value as string;
  } else {
    const { getCookie } = await import('cookies-next');
    wckRPImage = getCookie('wckRPImage') as string;
  }
  return wckRPImage;
};
